import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VideoRoutingModule } from './video-routing.module';
import { YoutubeVideosComponent } from './youtube-videos/youtube-videos.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [YoutubeVideosComponent],
  imports: [CommonModule, VideoRoutingModule, SharedModule],
})
export class VideoModule {}
